// extracted by mini-css-extract-plugin
export default {"container":"layout_container__59KtD","content":"layout_content__wx6TA","main":"layout_main__9nyCT","submenuOpen":"layout_submenuOpen__soaSO"};